<div class="flex flex-col-reverse gap-4 w-full lg:max-h-[450px] lg:flex-row">

    <div
        class="flex flex-col gap-6 pr-1 overflow-y-auto lg:overflow-y-auto w-full  max-h-[450px] lg:pr-6 lg:w-[40%] lg:flex-1">
        <!-- Valida Si existe sesion-->
        <ng-container *ngIf="(userSessionIsChecked == false); else sessionUserOk">
            <mat-slide-toggle [color]="color" [(ngModel)]="isChecked" disabled>
                ¡SOLO URGENCIAS!
            </mat-slide-toggle>
        </ng-container>
        <ng-template #sessionUserOk>
            <mat-slide-toggle [color]="color" [(ngModel)]="isChecked" (change)="onToggleChange()">
                ¡SOLO URGENCIAS!
            </mat-slide-toggle>
        </ng-template>
        <button
            class="w-fit text-black font-bold py-2 px-5 rounded-full flex items-center shadow-md shadow-gray-400 mb-2 hover:brightness-95"
            style="background-color: #f6b93b;"
            (click)="toggleTipoC()">
            {{ isTipoCActive ? 'Mostrar veterinarias' : 'Pet friendly' }}
        </button>

        <ng-container *ngIf="isTipoCActive; else tarjetasNormales">
            <div class="flex p-3 justify-between items-center rounded-lg cursor-pointer"
                style="background-color: #f6b93b;"
                *ngFor="let vet of tipoCVeterinarias"
                (click)="enfocarVet(vet)">
                <div class="flex flex-col gap-1 text-black">
                    <span class="font-bold">{{vet.nombre || '-- --'}}</span>
                    <span class="{{vet.esAnuncio ? 'text-red-500' : ''}}">{{vet.esAnuncio ? 'VETERINARIA CERRADA' :
                        'DISPONIBLE'}}</span>
                    <span>{{vet.otros || '-- --'}}</span>
                    <span class="font-bold">Jornada completa</span>
                </div>
            </div>
        </ng-container>
        <ng-template #tarjetasNormales>
            <ng-container *ngIf="(isChecked); else completeData">
                <div class="flex p-3 justify-between items-center rounded-lg cursor-pointer"
                    style="background-color: #d63031;"
                    *ngFor="let vet of urgencias"
                    (click)="enfocarVet(vet)">
                    <div class="flex flex-col gap-1 text-white">
                        <span class="font-bold">{{vet.nombre || '-- --'}}</span>
                        <span class="{{vet.esAnuncio ? 'text-red-500' : ''}}">{{vet.esAnuncio ? 'VETERINARIA CERRADA' :
                            'DISPONIBLE'}}</span>
                        <span>{{vet.otros || '-- --'}}</span>
                        <span class="font-bold">{{ vet.fullJornada ? 'Jornada completa': (vet.horaApertura ) + ' - ' +
                            vet.horaCierre}}</span>
                    </div>
                </div>
            </ng-container>
            <ng-template #completeData>
                <div class="flex p-3 justify-between items-center bg-pet-color-5 rounded-lg cursor-pointer"
                    *ngFor="let vet of veterinarias"
                    (click)="enfocarVet(vet)">
                    <div class="flex flex-col gap-1 text-white">
                        <span class="font-bold ">{{vet.nombre || '-- --'}}
                            <span class="{{vet.esAnuncio ? 'text-red-500' : ''}}">{{vet.esAnuncio ? 'VETERINARIA
                                CERRADA' : 'DISPONIBLE'}}</span>
                        </span>
                        <span>{{vet.otros || '-- --'}}</span>
                        <span class="font-bold">{{ vet.fullJornada ? 'Jornada completa': (vet.horaApertura ) + ' - ' +
                            vet.horaCierre}}</span>
                    </div>
                    <ng-container *ngIf="(!vet.fullJornada )">
                        <button
                            class="bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-5 rounded-full flex items-center shadow-md shadow-gray-400"
                            (click)="goToAgendarCita(vet)">
                            Agendar
                        </button>
                    </ng-container>
                </div>
            </ng-template>
        </ng-template>

    </div>

    <div id="mappets" class="flex w-full h-[250px] md:h-[450px] lg:w-[60%] lg:flex-2">
        <!--<img src="https://joomly.net/frontend/web/images/googlemap/map.png" alt="" class="w-full">-->
    </div>

</div>
<a style="display: none;" href="https://www.flaticon.com/free-icons/pin" title="pin icons">Pin icons created by Freepik
    - Flaticon</a>